import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import {Button, Input} from 'ui-library';
import {get} from 'lodash';
import i18n from 'i18n';

import API from '../lib/api.js';
import Mixins from '../lib/mixins';

import SettingsAccountContent from './settings-account-content-readonly';
import UserSettingsLocationPhoneReadonly from 'modules/accounts/influencer/containers/UserSettingsLocationPhoneReadonly';
import {CustomizableAlert} from 'modules/shared/components';
import {openChat} from 'utils/crispActions';
import VerificationLabel from 'modules/accounts/influencer/containers/VerificationLabel/VerificationLabel';
import DeleteInfluencerUser from 'modules/accounts/influencer/containers/DeleteInfluencerUser';
import passwordRegex from '../mixins/passwordRegex';

import {displayAlert} from '../actions/app';

const MIN_LENGTH_FOR_PASSWORD = 6;
const PROFILE_VERIFICATION = '/account/verification';

const SettingsAccountReadOnly = createClass({

  mixins: [
    LinkedStateMixin,
    Mixins.linkMixin,
    passwordRegex
  ],

  propTypes: {
    user: PropTypes.object,
    account: PropTypes.object,
    changePage: PropTypes.func,
    startCurrentUserVerificationRequest: PropTypes.func
  },

  getInitialState() {
    return {
      emailInput: '',
      changingPassword: false,
      passwordToChange: '',
      currentPassword: '',
      showDelete: false,
      hoverCancel: false,
      password: '',
      errorMessage: null
    };
  },

  componentWillMount() {
    API.getUserMe();

    const email = get(this.props.user, 'email');
    this.setState({emailInput: email});
  },

  saveUserInfo() {
    this.refs.settingsUserInfo.saveData();
  },

  saveUserLocationPhone() {
    this.refs.settingsLocationPhone.saveData();
  },

  onEmailChange(event) {
    this.setState({
      emailInput: event.target.value
    });
  },

  onDeleteSelect() {
    this.setState({
      showDelete: true
    });
  },

  onCancelDelete() {
    this.setState({
      showDelete: false,
      hoverCancel: false
    });
  },

  isValidPassword(passwordToChange) {
    return this.passwordRegex.test(passwordToChange);
  },

  onShowChangePassword() {
    this.setState({
      changingPassword: true
    });
  },

  onSavePassword() {
    const {emailInput, changingPassword, passwordToChange, currentPassword} = this.state;
    const data = {
      email: emailInput,
      currentPassword
    };

    this.setState({validationActive: false, errorMessage: ''});

    if (changingPassword && !this.isValidPassword(passwordToChange)) {
      this.setState({
        validationActive: true,
        errorMessage: i18n.get('RESET_PASSWORD_INVALID_LENGTH')
      });
      return;
    }

    if (!this.validateProperty('currentPassword', currentPassword) ||
        !this.validateProperty('passwordToChange', passwordToChange)) {
      this.setState({
        validationActive: true
      });
      return;
    }

    if (changingPassword && passwordToChange !== '') {
      data.password = passwordToChange;
    }

    API.updatePasswordUser(data, (err, res) => {
      if (res.code) {
        displayAlert({
          type: 'error',
          message: res.message
        });
        return;
      }

      displayAlert({
        type: 'success',
        message: i18n.get('INF_SETTINGS_ACCOUNT_SUCCESS_ALERT')
      });
    });
  },

  validateTypes: {
    password: (val) => val.length >= MIN_LENGTH_FOR_PASSWORD,
    passwordToChange: (val, component) => val.length >= MIN_LENGTH_FOR_PASSWORD || !component.state.changingPassword,
    currentPassword: (val) => val.length >= MIN_LENGTH_FOR_PASSWORD
  },

  renderConfig() {
    const {user} = this.props;
    const {emailInput, changingPassword, errorMessage} = this.state;
    const lockDataMessage = (
      <p>
        {i18n.get('INF_SETTINGS_ACCOUNT_LOCK_DATA_MESSAGE_PART_1')}
        {' '}
        <a href='#' onClick={openChat}>
          {i18n.get('INF_SETTINGS_ACCOUNT_LOCK_DATA_MESSAGE_LINK_TEXT')}
        </a>
        {' '}
        {i18n.get('INF_SETTINGS_ACCOUNT_LOCK_DATA_MESSAGE_PART_2')}
      </p>
    );

    return (
      <div>
        <div className='vf-row padding-top-2x'>
          <div className='col-xs-12 col-md-offset-1'>
            <h2>{i18n.get('INF_SETTINGS_ACCOUNT_PERSONAL_TITLE')}</h2>
          </div>
        </div>
        <div className='vf-row reverse-sm padding-top-1x'>
          <div className='col-xs-12 col-sm-3'>
            <div className='vf-descriptor'>

            </div>
          </div>
          <div className='col-xs-12 show-xs padding-top-2x' />
          <div className='col-xs-12 col-sm-8'>
            <SettingsAccountContent
              ref='settingsUserInfo'
              user={user} />
          </div>
        </div>

        <div className='vf-row padding-top-2x'>
          <div className='col-xs-12 col-md-offset-1'>
            <h2>{i18n.get('INF_SETTINGS_ACCOUNT_LOCATION_AND_PHONE_TITLE')}</h2>
          </div>
        </div>
        <div className='vf-row reverse-sm padding-top-1x'>
          <div className='col-xs-12 col-sm-3'>
            <div className='vf-descriptor'>

            </div>
          </div>
          <div className='col-xs-12 show-xs padding-top-2x' />
          <div className='col-xs-12 col-sm-8'>
            <div className='vf-row'>
              <div className='col-xs-12 col-md-offset-4 col-md-8'>
                <UserSettingsLocationPhoneReadonly user={user} />
              </div>
            </div>
          </div>
        </div>

        <div className='vf-row reverse-sm padding-top-1x'>
          <div className='col-xs-12 col-sm-3'>
            <div className='vf-descriptor'>

            </div>
          </div>
          <div className='col-xs-12 show-xs padding-top-2x' />
          <div className='col-xs-12 col-sm-8'>
            <div className='vf-row'>
              <div className='col-xs-12 col-md-offset-4 col-md-7'>
                <CustomizableAlert
                  title={i18n.get('INF_SETTINGS_ACCOUNT_LOCK_DATA_MESSAGE_TITLE')}
                  markupContent={lockDataMessage}
                  imageType='warning'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='vf-row padding-top-3x'>
          <div className='col-xs-12 col-md-offset-1'>
            <h2>{i18n.get('INF_SETTINGS_ACCOUNT_EMAIL_AND_PASSWORD_TITLE')}</h2>
          </div>
        </div>
        <div className='vf-row reverse-sm padding-top-1x'>
          <div className='col-xs-12 col-sm-3'>
            <div className='vf-descriptor'>

            </div>
          </div>
          <div className='col-xs-12 show-xs padding-top-2x' />
          <div className='col-xs-12 col-sm-8'>
            <div className='vf-row'>
              <div className='col-xs-12 col-md-offset-4 col-md-5'>
                <div className='padding-nonlateral'>
                  <label className='vf-descriptor'>
                    {i18n.get('INF_SETTINGS_ACCOUNT_EMAIL_LABEL')}
                  </label>
                  <div>
                    <Input value={emailInput} onChange={this.onEmailChange} data-uitest='email-input'/>
                  </div>
                </div>

                <div className='padding-top-1x'>
                  <label className='vf-descriptor vf-block'>
                    {i18n.get('INF_SETTINGS_ACCOUNT_PASSWORD_LABEL')}
                  </label>
                  {changingPassword ? (
                    <Input data-uitest='password-input' type='password' placeholder={i18n.get('INF_SETTINGS_ACCOUNT_PASSWORD_PLACEHOLDER')} {...this.linkedValidation('passwordToChange')} />
                  ) : (
                    <Button size='sm' onClick={this.onShowChangePassword} data-uitest='change-password-button'>
                      {i18n.get('INF_SETTINGS_ACCOUNT_CHANGE_PASSWORD_LABEL')}
                    </Button>
                  )}

                  {errorMessage &&
                    <div>
                      <span className='vf-text-danger'>
                        {errorMessage}
                      </span>
                    </div>}
                </div>

                <div className='padding-top-1x'>
                  <label className='vf-descriptor'>
                    {i18n.get('INF_SETTINGS_ACCOUNT_CURRENT_PASSWORD_LABEL')}
                  </label>
                  <Input data-uitest='current-password-input' type='password' placeholder={i18n.get('INF_SETTINGS_ACCOUNT_CURRENT_PASSWORD_LABEL')} {...this.linkedValidation('currentPassword')} />
                </div>

                <div className='padding-top-3x'>
                  <Button color='primary' onClick={this.onSavePassword} data-uitest='save-changes-button'>
                    {i18n.get('INF_SETTINGS_ACCOUNT_SAVE_BUTTON')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='vf-row reverse-sm padding-top-3x'>
          <div className='col-xs-12 col-sm-3'></div>
          <div className='col-xs-12 col-sm-8'>
            <div className='vf-row'>
              <div className='col-xs-12 col-md-offset-4 col-md-5'>
                <a onClick={this.onDeleteSelect} data-uitest='delete-account-link'>
                  {i18n.get('INF_SETTINGS_ACCOUNT_DELETE_BUTTON')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },

  render() {
    const {account} = this.props;
    const {user, changePage, startCurrentUserVerificationRequest} = this.props;
    const {showDelete} = this.state;
    const content = showDelete ? <DeleteInfluencerUser account={account} onCancelDelete={this.onCancelDelete} /> : this.renderConfig();

    return (
      <div className='vf-wrapper'>
        <VerificationLabel
          user={user}
          onVerify={() => {
            startCurrentUserVerificationRequest();
            changePage(PROFILE_VERIFICATION);
          }}
        />
        {content}
      </div>
    );
  }

});

export default SettingsAccountReadOnly;
